import interact from 'interactjs'
import {
    resizeDataTableFilter
} from "@/components/layer/info/filter/layer-info-filter-result-component";
import {resizeDataTable} from "@/helpers/datatable/datatable-helper";
import {checkHeaderArrows} from "@/helpers/layer/info/layer-info-info-helper";
import {getBySelector} from "@/helpers/element-helper";

function disableSelect(event) {
    event.preventDefault();
}


export function initInteract() {
    const positionLayerMenu = { x: 0, y: 0 }
    const position = { x: 0, y: 0 }

    interact('.layer-menu').draggable({
        allowFrom: 'layer-menu-switcher-button-active',
        modifiers: [
            interact.modifiers.restrictRect({
                restriction: 'body'
            })
        ],
        listeners: {
            move (event) {
                window.addEventListener('selectstart', disableSelect);
                positionLayerMenu.x += event.dx
                positionLayerMenu.y += event.dy

                event.target.style.transform =
                    `translate(${positionLayerMenu.x}px, ${positionLayerMenu.y}px)`
            },
            end: function () {
                window.removeEventListener('selectstart', disableSelect);
            }
        }
    }).resizable({
        allowFrom: '.layer-menu',
        modifiers: [
            interact.modifiers.restrictSize({
                min: { width: 200, height: 200 },
            })
        ],
        edges: { right: true },
        listeners: {
            move: function (event) {
                window.addEventListener('selectstart', disableSelect);
                let { x, y } = event.target.dataset

                x = (parseFloat(x) || 0) + event.deltaRect.left
                y = (parseFloat(y) || 0) + event.deltaRect.top

                const targetStyle = {
                    width: `${event.rect.width}px`
                }

                Object.assign(event.target.style, targetStyle)
                Object.assign(event.target.dataset, { x, y })
            },
            end: function () {
                window.removeEventListener('selectstart', disableSelect);
            }
        }
    })

    interact('.info-menu')
    .draggable({
        modifiers: [
            interact.modifiers.restrictRect({
                restriction: 'body'
            })
        ],
        allowFrom: '.info-menu-info-draggable',
        listeners: {
            move (event) {
                window.addEventListener('selectstart', disableSelect);
                position.x += event.dx
                position.y += event.dy

                event.target.style.transform = `translate(${position.x}px, ${position.y}px)`

                window.windowSettings.transform = event.target.style.transform
            },
            end: function () {
                window.removeEventListener('selectstart', disableSelect);
            }
        }
    }).resizable({
        allowFrom: '.info-menu-content',
        modifiers: [
            interact.modifiers.restrictSize({
                min: { width: 300, height: 300 },
            })
        ],
        edges: { left: true, bottom: true },
        listeners: {
            move: function (event) {
                window.addEventListener('selectstart', disableSelect);

                let { x, y } = event.target.dataset

                // console.log(event)

                x = (parseFloat(x) || 0) + event.deltaRect.left
                y = (parseFloat(y) || 0) + event.deltaRect.top

                const targetStyle = {
                    width: `${event.rect.width}px`
                }

                if(document.querySelector('layer-info-filter').classList.contains('d-none')) {
                    targetStyle.height = `${event.rect.height}px`
                }

                Object.assign(event.target.style, targetStyle)
                Object.assign(event.target.dataset, { x, y })

                const height = event.rect.height - 300

                window.windowSettings.width = event.rect.width
                window.windowSettings.height = event.rect.height


                resizeDataTableFilter(height)
                resizeDataTable()
                checkHeaderArrows()

                if(window.activeChart) {
                    window.activeChart.resize()
                }
            },
            end: function () {
                window.removeEventListener('selectstart', disableSelect);
            }
        }
    })

    interact('.DTE')
        .draggable({
            modifiers: [
                interact.modifiers.restrictRect({
                    restriction: 'body'
                })
            ],
            allowFrom: '.DTE_Header',
            listeners: {
                move (event) {
                    window.addEventListener('selectstart', disableSelect);
                    position.x += event.dx
                    position.y += event.dy

                    event.target.style.transform = `translate(${position.x}px, ${position.y}px)`

                    window.windowModalSettings.transform = event.target.style.transform
                },
                end: function () {
                    window.removeEventListener('selectstart', disableSelect);
                }
            }
        }).resizable({
        allowFrom: '.DTE',
        modifiers: [
            interact.modifiers.restrictSize({
                min: { width: 300, height: 300 },
            })
        ],
        edges: { top: true, left: true, bottom: true, right: true },
        listeners: {
            move: function (event) {
                window.addEventListener('selectstart', disableSelect);

                const edges = event.edges;

                let { x, y } = event.target.dataset;
                x = parseFloat(x) || 0;
                y = parseFloat(y) || 0;

                if (edges.left) {
                    x += event.deltaRect.left;
                }
                if (edges.top) {
                    y += event.deltaRect.top;
                }

                const targetStyle = {
                    width: `${event.rect.width}px`,
                    height: `${event.rect.height}px`,
                }


                Object.assign(event.target.style, targetStyle)
                Object.assign(event.target.dataset, { x, y })


                window.windowModalSettings.width = event.rect.width
                window.windowModalSettings.height = event.rect.height
            },
            end: function () {
                window.removeEventListener('selectstart', disableSelect);
            }
        }
    })
}
